module.exports = __webpack_public_path__ + "img/editar.3c456da2.png";